import type { ClipboardDocument } from "@/features/clipboard/api/clipboard";

export const clipboardDocumentFileType = (doc: ClipboardDocument): string => {
  if (doc.source_type === "link") return "Linked paper";
  if (doc.source_type === "bib") return "Bibliography";
  const extension = doc.filename.match(/\.([^.]+)$/)?.[1];
  return extension ? extension.toUpperCase() : "Document";
};
